import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import CommonTable from '../../CommonTable/CommonTable';
import { updatePaymentGatewayStatus } from '../../../actions/siteadmin/updatePayemntGatewayStatus';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';
import messages from '../../../locale/jsonMessages';
import s from './ManagePaymentGateway.css';
class ManagePaymentGateway extends React.Component {
    static propTypes = {
        getAllPayments: PropTypes.shape({
            loading: PropTypes.bool,
            refetch: PropTypes.any.isRequired,
            getAllPaymentMethods: PropTypes.array
        }),
        title: PropTypes.string.isRequired,
    };

    async handleUpdate(id, e) {
        const { updatePaymentGatewayStatus, getAllPayments: { refetch }, demoRestriction } = this.props;
        let isEnable = e.target.value;
        isEnable = isEnable == 'true' ? true : false;
        const isRestrict = await demoRestriction({});
        if (isRestrict) return;
        await updatePaymentGatewayStatus(id, isEnable);
        refetch();
    }

    thead = () => {
        const { formatMessage } = this.props.intl;
        return [
            { data: formatMessage(messages.idLabel) },
            { data: formatMessage(messages.paymentGateway) },
            { data: formatMessage(messages.status) }
        ]
    };

    tbody = (props) => {
        const { getAllPayments: { getAllPaymentMethods } } = props;
        const { formatMessage } = this.props.intl;

        return getAllPaymentMethods?.map(value => {
            return {
                id: value?.id,
                data: [
                    { data: value?.id },
                    {
                        data: value?.paymentName
                    },
                    {
                        data: <div>
                            <select className='commonTableInsideSelect' value={value.isEnable} onChange={(e) => this.handleUpdate(value.id, e)}>
                                <option value={true}>{formatMessage(messages.activeLabel)}</option>
                                <option value={false}>{formatMessage(messages.inActiveLabel)}</option>
                            </select>
                        </div>
                    },
                ]
            }
        })
    }

    render() {
        const { formatMessage } = this.props.intl;

        return (
            <CommonTable
                thead={this.thead}
                tbody={() => this.tbody(this.props)}
                title={formatMessage(messages.managePaymentGateWay)}
            />
        )
    }

}

const mapState = (state) => ({});

const mapDispatch = {
    updatePaymentGatewayStatus,
    demoRestriction
};

export default compose(injectIntl, withStyles(s), connect(mapState, mapDispatch))(ManagePaymentGateway);